
import { Iapi_version } from "../../types";
const getApiWithVersion = (apiVersion: Iapi_version) => {
  const APIS = {

    ADDRESS: `api/${apiVersion}/address`,
    ADDRESS_ADD: `api/${apiVersion}/add-Address`,
    ADDRESS_LiST: `api/${apiVersion}/address`,
    ALL_FAQS: `api/${apiVersion}/all-faqs`,
    APPLIANCES: `api/${apiVersion}/appliances`,
    ADDRESS_UPDATE: `api/${apiVersion}/update-user-Address`,

    BRAND: `api/${apiVersion}/brands`,
    BLOG_LIST: `api/${apiVersion}/blogs/get-blog-post-list`,
    BLOG_CATEGORY: `api/${apiVersion}/blogs/get-blog-post-category`,
    BLOG_POST_DETAIL: `api/${apiVersion}/blogs/get-blog-post-detail`,


    CONTACT_US: `api/${apiVersion}/tempelate`,
    CART_ADD_TO_CART: `api/${apiVersion}/add-to-cart`,
    CART_DELETE_ITEMS: `api/${apiVersion}/delete-cart-item`,
    CART_ITEMS: `api/${apiVersion}/cart-items`,
    CART_UPDATE_Price: `api/${apiVersion}/update-price`,
    CHECK_AUTH: `api/${apiVersion}/check-auth`,
    COUPON_APPLY: `api/${apiVersion}/cartcoupons`,
    COUPON_LIST: `api/${apiVersion}/coupons`,
    COUPON_REMOVE: `api/${apiVersion}/coupon-remove`,
    CHAT_WIDGET: `api/${apiVersion}/chatbot`,
    // D
    DELETE_ADDRESS: `api/${apiVersion}/delete-user-address`,
    DELETE_USER: `api/${apiVersion}/user/delete-user`,

    // F
    FEEDBACK_ABOUT_US: `api/${apiVersion}/template/about_us_page`,

    GEO_COORDS: `api/${apiVersion}/geocode`,  //prev
    // GEO_COORDS: `api/${apiVersion}/getCoords`,


    HOME_CONTENT: `api/${apiVersion}/home-content`,

    LOGIN: `api/${apiVersion}/login`,
    LOCATION_LOG: `api/${apiVersion}/location-save`,


    MEDIA_LOGO: `api/${apiVersion}/media-fetch`,

    ORDER_SCHEDULE_DATE: `api/${apiVersion}/warehouse/order-assign-slots`,
    ORDER_COMPLETE: `api/${apiVersion}/order-complete`,
    ORDERS: `api/${apiVersion}/orders`,
    FETCH_REFERRAL: `api/${apiVersion}/fetch-referrals`,
    SEO_META_DETAILS: `api/${apiVersion}/seo-meta-details`,
    FETCH_USER: `api/${apiVersion}/fetch-user`,

    UPDATE_USER: `api/${apiVersion}/update-user`,
    REMOVE_USER_OTP: `api/${apiVersion}/user/remove-otp`,

    // ADDRESS: `api/${apiVersion}/address`,
    // GET_COORDS: `api/${apiVersion}/getCoords`,
    ORDER_ADDRESS: `api/${apiVersion}/orderAdd`,

    CANCEL_REASONS: `api/${apiVersion}/cancel-reason`,

    CANCEL_ORDER: `api/${apiVersion}/cancel-order`,
    RESCHEDULE_ORDER: `api/${apiVersion}/reschedule-order`,




    PINCODE: `api/${apiVersion}/pincode`,
    PRODUCT_SEARCH: `api/${apiVersion}/product/search`,
    PRODUCT_CATEGORIES: `api/${apiVersion}/product-categories`,
    PRODUCT_BASED_ON_ATTRIBUTE: `api/${apiVersion}/attribute-based`,
    PRODUCT_SLUG: `api/${apiVersion}/product-slug`,
    PRODUCT_ATTRIBUTE: `api/${apiVersion}/product-attribute`,
    PRODUCT_CHILD_ATTRIBUTES: `api/${apiVersion}/product-child`,
    PRODUCT_CATEGORY_DETAILS: `api/${apiVersion}/category-detail`,
    PRODUCT_DEFAULT_PRICE: `api/${apiVersion}/product-default-price`,
    PRODUCT_VOUCHER_AND_PRICE: `api/${apiVersion}/product-voucher`,
    PRODUCT_SERVICIABILITY_CHECk: `api/${apiVersion}/product-service`,

    REGISTER: `api/${apiVersion}/user/create`,
    RESEND_OTP: `api/${apiVersion}/resend-otp`,
    RESEND_OTP_EXPIRE: `api/${apiVersion}/resend-otp-expire`,
    PROFILE_UPDATE: `api/${apiVersion}/user/profileUpdate`,


    // SEO_META_DETAILS: `api/${apiVersion}/seo-meta-details`,
    SEO_CONTENT: `api/${apiVersion}/seo-content-cat`,
    SESSION_CART: `api/${apiVersion}/session-cart`,
    UPDATE_DETAIL: `api/${apiVersion}/update`,
    UPDATE_LIST: `api/${apiVersion}/updates/getUpdateList`,
    UPDATE_CATEGORIES: `api/${apiVersion}/updates/categories`,

    USER_LOG: `api/${apiVersion}/user-log`,
    UTM_QUERY: `api/${apiVersion}/utm-campaign-tracking`,


    VERIFY_OTP: `api/${apiVersion}/verify-otp`,
    VOUCHER_REMOVE: `api/${apiVersion}/voucher/update-or-remove-voucher`,
    VOUCHER_LIST: `api/${apiVersion}/voucher/get-order-and-item-voucher`,
    VOUCHERS: `api/${apiVersion}/voucher/get-all-vouchers`,
    VOUCHERS_CAT: `api/${apiVersion}/voucher/get-vouchers`,

    PRODUCT_SERVICE: `api/${apiVersion}/product-service`,

    STATIC_PAGE: `api/${apiVersion}/page`
  };

  return APIS;
};
export default getApiWithVersion;
